import { QUOTE } from "../../data/content";
import { Reveal } from "./Reveal";

export const Quote = () => {
  return (
    <section
      data-testid="quote"
      className="relative grain overflow-hidden border-t px-6 py-28 lg:px-10 lg:py-40"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-5xl text-center">
        <Reveal>
          <span
            className="font-head block text-7xl leading-none sm:text-8xl"
            style={{ color: "var(--accent)" }}
            aria-hidden
          >
            &ldquo;
          </span>
          <blockquote className="font-head -mt-6 text-3xl leading-snug text-[color:var(--text)] sm:text-4xl lg:text-5xl">
            {QUOTE.text}
          </blockquote>
          <p
            className="font-accent mt-10 text-[11px] uppercase tracking-[0.3em]"
            style={{ color: "var(--accent)" }}
          >
            — {QUOTE.cite}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
